/**
 * Show an info flash that does auto-remove
 *
 * @see show
 */
function info(message, options = {}) {
  show(message, { ...options, type: "info" });
}

/**
 * Show a success flash that does auto-remove
 *
 * @see show
 */
function success(message, options = {}) {
  show(message, { ...options, type: "success" });
}

/**
 * Show a warning flash that does auto-remove
 *
 * @see show
 */
function warning(message, options = {}) {
  show(message, { ...options, type: "warning" });
}

/**
 * Show an error flash that does not auto-remove
 *
 * @see show
 */
function error(message, options = {}) {
  show(message, { autoremove: false, ...options, type: "error" });
}

function buildActionLink({ href, label }) {
  const link = document.createElement("a");

  link.setAttribute("slot", "append");
  link.href = href;
  link.textContent = label;

  return link;
}

/**
 * Show a flash with the given message
 *
 * @param {string} message
 * @param {Object} options
 * @property {number} options.autoremoveDelay - autoremove duration in ms
 * @property {boolean} options.autoremove - whether to autoremove, defaults to true, or to false when `action` is given
 * @property {string} options.type - flash type, defaults to 'info'
 * @property {boolean} options.closeable - whether to show a close button, defaults to true
 * @property {boolean|string} options.icon - whether to show an icon, defaults to false (or a string with the icon name)
 * @property {{ href: string, label: string }} options.action - a link rendered after the message
 */
function show(message, options = {}) {
  const {
    action,
    type = "info",
    autoremoveDelay = 3000,
    autoremove = !action,
    closeable = true,
    icon = false,
    target = document.body,
  } = options ?? {};

  const flash = document.createElement("sp-alert");

  flash.setAttribute("type", type);
  flash.setAttribute("text", message);
  flash.setAttribute("closeable", closeable);
  flash.setAttribute("icon", icon);
  flash.setAttribute("flash", true);
  flash.setAttribute("variant", "elevated");

  if (action) {
    flash.append(buildActionLink(action));
  }

  if (autoremove) {
    setTimeout(() => flash.remove(), autoremoveDelay);
  }

  target.insertBefore(flash, target.firstChild);
}

export function useFlash() {
  return {
    info,
    success,
    warning,
    error,
    show,
  };
}
